module.exports = __webpack_public_path__ + "static/media/Exporting.ab3b02c2.svg";